import type { SxProps, Theme } from '@mui/material'

/**
 * The row treatment of a grouped entity search result: an inset, rounded row
 * with the kind icon, label, and trailing action spaced apart, tinted on hover
 * and more strongly while it is the keyboard-active row.
 *
 * `activeSelector` names the class the host list puts on its active row —
 * `ListItemButton` marks it `Mui-selected`, an `Autocomplete` option
 * `Mui-focused`. The result is a plain style object so a host can nest it under
 * its own row selector.
 */
export default function searchResultRowSx(activeSelector: '&.Mui-selected' | '&.Mui-focused') {
  return {
    px: 2,
    py: 1.5,
    mx: 2,
    gap: 2,
    alignItems: 'center',
    borderRadius: 1,
    transition: (theme: Theme) =>
      theme.transitions.create(['background-color'], { duration: theme.transitions.duration.shorter }),
    [`&:hover, ${activeSelector}:hover`]: { backgroundColor: 'action.hover' },
    [activeSelector]: { backgroundColor: 'action.selected' }
  } satisfies SxProps<Theme>
}
